import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import VoterStats from "@/pages/overview/components/VoterStats";
import { Select } from "@/config/antd";

const data = [
  { time: "09:00", supportive: 500000, neutral: 700000, opposive: 100000 },
  { time: "10:00", supportive: 400000, neutral: 800000, opposive: 150000 },
  { time: "11:00", supportive: 490000, neutral: 600000, opposive: 120000 },
  { time: "12:00", supportive: 580000, neutral: 730000, opposive: 110000 },
  { time: "13:00", supportive: 420000, neutral: 600000, opposive: 100000 },
  { time: "14:00", supportive: 630000, neutral: 890000, opposive: 140000 },
];

const HomeChart = () => {
  return (
    <div className="w-full rounded-md p-3 lg:p-5 border">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3">
        <div>
          <h3 className="text-small font-bold">ACCUMULATIONS</h3>
          <h1 className="mb-2 heading-large font-bold lg:text-3xl">
            Political Surveys
          </h1>
        </div>
        <Select
          labelInValue
          defaultValue={{
            value: "today",
            label: "Today",
          }}
          style={{
            width: "8.0625rem",
            height: "2.375rem",
            borderRadius: "5px",
          }}
          options={[
            { value: "today", label: "Today" },
            { value: "week", label: "This Week" },
            { value: "month", label: "This Month" },
          ]}
        />
      </div>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        <div>
          <h2 className="mb-2 text-3xl font-bold">949,220</h2>
          <div className="flex items-center">
            <div className="flex items-center gap-1 px-3 py-1 text-white rounded-full bg-green text-small-xs">
              <span>↑</span>
              <span>8.5%</span>
            </div>
            <p className="ml-2 text-small-xs text-darkGrey">
              from last 10 days
            </p>
          </div>
          <p className="mt-2 text-small">
            This is a graph of the performance of your how your survey is doing
            on a daily, weekly, and monthly basis.
          </p>
        </div>
        <div className="flex flex-col items-center w-full col-span-1 lg:col-span-2">
          <div className="w-full overflow-x-auto">
            <div className="min-w-[300px] w-full">
              <ResponsiveContainer width="100%" height={200}>
                <LineChart data={data}>
                  <CartesianGrid stroke="#f0f0f0" strokeDasharray="3 3" />
                  <XAxis
                    dataKey="time"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "#4B5563", fontSize: 12 }}
                    padding={{ left: 0, right: 0 }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "#4B5563", fontSize: 12 }}
                    tickFormatter={(value) => `${value / 1000}K`}
                    ticks={[10000, 100000, 200000, 500000, 1000000]}
                    domain={[0, 1000000]}
                  />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="supportive"
                    stroke="#22c55e"
                    strokeWidth={2}
                  />
                  <Line
                    type="monotone"
                    dataKey="neutral"
                    stroke="#f59e0b"
                    strokeWidth={2}
                  />
                  <Line
                    type="monotone"
                    dataKey="opposive"
                    stroke="#ef4444"
                    strokeWidth={2}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="w-full mt-3">
            <VoterStats />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeChart;
